import { trackingEvent } from '@notino/web-tracking';

import { EOrderAsLastTimeState } from '@model';
import { getTrackingProductName } from '@utils/tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { mapOaltStateToEcommerce } from '../../mappers';
import { ECartType, EcommerceSectionNamespace, IEcommerceCheckout } from '../../model';

/**
 * Ecommerce event Close Purchase for OaLT
 * This event should be called once customer close the Oalt Modal
 * @param checkout - Ecommerce object of checkout - summary of cart
 */
export const trackCheckoutCloseRepeatedPurchase = (checkout: IEcommerceCheckout, oaltState: EOrderAsLastTimeState) => {
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.CHECKOUT_CLOSE_REPEATED_PURCHASE,
      checkout: {
        revenue: checkout.revenue.toString(),
        tax: checkout.tax.toString(),
        total_value: checkout.totalValue.toString(),
        ...(checkout.shipping && { shipping: checkout.shipping.toString() }),
        cart_type: ECartType.Cart,
        payment_type: checkout.paymentType,
        delivery_type: checkout.deliveryType,
        products: checkout.products.map((product) => ({
          product_code: product.productCode,
          product_name: getTrackingProductName(product),
          brand_name: product.brandName,
          primary_category: product.primaryCategories.category,
          primary_subcategory: product.primaryCategories.subCategory,
          primary_type: product.primaryCategories.type,
          kind: product.primaryCategories.kind,
          full_price: product.fullPrice,
          availability: product.stockAvailability,
          price: product.price,
        })),
      },
      dialog: {
        name: mapOaltStateToEcommerce(oaltState),
        type: checkout.providerType ?? '',
        value: checkout.totalValue,
      },
      _clear: true,
    }),
  );
};
